export const ftmAvailabilityStatuses = {
    1: 'Active',
    2: 'Pending',
    3: 'Suspended',
    4: 'On leave',
    5: 'Banned',
}